// Base configuration with common settings
const config = {
  // API endpoints
  api: {
    getTests: '/api.php?action=get_tests',
    sendOtp: '/api.php?action=sendotp',
    verifyOtp: '/api.php?action=verifyotp'
  },
  
  // Other common settings can be added here
  appName: 'Lakshya Jalandhar',
  version: '1.0.0'
};

export default config; 